import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Permission } from '@uzurv/core';
// eslint-disable-next-line import/order
import { UzurvRestConfiguration, UzurvRestService, UZURV_REST_CONFIGURATION } from '@uzurv/http';
import { Deserialize } from 'cerialize';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PermissionService extends UzurvRestService {
  readonly resourceUrl = 'permissions/';

  constructor(
    protected httpClient: HttpClient,
    @Inject(UZURV_REST_CONFIGURATION) protected uzurvRestConfiguration: UzurvRestConfiguration,
    protected domSanitizer: DomSanitizer
  ) {
    super(httpClient, uzurvRestConfiguration, domSanitizer);
  }

  /**
   * Returns a list of all permissions
   *
   * @param pageNumber
   * @param pageSize
   */
  listAll(pageNumber: number, pageSize: number): Observable<Array<Permission>> {
    return this.get(this.resourceUrl, { pageNumber: pageNumber, pageSize: pageSize }).pipe(map(response => Deserialize(response, Permission)));
  }
}
